import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";
import { IconProps } from "@/common/contracts/icon.contracts";

/* Sprite-backed: PDP seller badge; the path lives in `IconSprite`. */
export const MedalOutline = (props: IconProps) => {
  return (
    <SpriteIcon
      symbol={SPRITE_SYMBOLS.medalOutline}
      width="24"
      height="25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    />
  );
};
